<div
  class="page"
  [contextMenuTrigger]="menu"
  [menuContext]="{ value: invDailyWasteSetting, visible: formVisible, settingChanges$: settingChanges$ }"
  (menuAction)="($event)">
  <ssg-select
    *ngIf="isMultiBranch"
    name="branchFilter"
    class="branch-filter"
    [multiple]="true"
    [group]="formGroup"
    dropdownPosition="auto"
    limitSelection="5"
    userClass="select-md"
    [hasSelectAll]="true"
    [label]="'General.Branch' | translate"
    (valueChange)="onBranchFilterChanged($event)"
    (valueClear)="onBranchFilterClear()"
    [dataList]="allBranchesExceptCallCenter"
    textFieldName="Title"
    valueFieldName="Id"
    style="position: relative; left: 10px">
  </ssg-select>
  <kgrid
    [apiName]="apiName"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    reportName="InvDailyWaste"
    pathPreFix="SALE"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [isEdit]="isEdit"
    [isDelete]="isDelete"
    [filters]="onFilter"
    [isModal]="false">
  </kgrid>
</div>
